"use strict";
/**
 * @module Services.RemoteServers
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var remote_servers_1 = require("../../../features/remote-servers");
var BEES = require("../../serialisers/byte-encoded-enum-serialiser");
/**
 * Read a remote server from the stream
 *
 * @param bis  the input stream
 * @return     the {@link RemoteServer} that was read
 */
function readRemoteServer(bis) {
    var name = Codec.readString(bis);
    var url = Codec.readString(bis);
    var principal = Codec.readString(bis);
    var connectionOptions = Codec.readObject(bis, function (s) { return BEES.read(s, remote_servers_1.ConnectionOption); }, Codec.readString);
    var missingTopicNotificationFilter = Codec.readString(bis);
    return {
        name: name,
        url: url,
        principal: principal,
        connectionOptions: connectionOptions,
        missingTopicNotificationFilter: missingTopicNotificationFilter !== ''
            ? missingTopicNotificationFilter
            : undefined
    };
}
exports.readRemoteServer = readRemoteServer;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/remote-servers/read-remote-server.js
// module id = 814
// module chunks = 1